import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import isEmpty from 'lodash/isEmpty';
import { FormattedMessage } from 'react-intl';

import history from 'aurora-utils/history';
import messages from 'aurora-translations';
import { getPropertyTitle } from 'aurora-utils/utils';
import ADGMImage from '../../../ADGMImage';
import styles from './styles';

function AddProperty(props) {
  const { classes, locale, buttonText, propertyURL, properties, handleRemove } = props;

  const getCommunity = useCallback(prop => {
    if (locale === 'ar') {
      return prop?.commUnityNameAr || prop?.communityNameAr || prop?.communityAr || prop?.community;
    }
    return prop?.commUnityNameEn || prop?.communityNameEn || prop?.communityEn || prop?.community;
  }, []);

  return (
    <>
      {!isEmpty(properties) && (
        <div className={classes.listContainer}>
          {(properties || []).map(prop => {
            return (
              <div className={classes.listItem} key={prop.plotID}>
                <div>
                  <ADGMImage name='Land.png' alt='land' />
                </div>
                <div className={classes.details}>
                  <Typography component='p'>{getCommunity(prop)}</Typography>
                  <Typography component='p'>{getPropertyTitle(prop)}</Typography>
                  <Typography component='p'>{prop.plotID}</Typography>
                </div>
                <div>
                  <Button onClick={() => handleRemove(prop.plotID)}>
                    <FormattedMessage {...messages.remove} />
                  </Button>
                </div>
              </div>
            );
          })}
        </div>
      )}
      <div className={classes.buttonContainer}>
        <Button
          variant='outlined'
          className={classes.button}
          size='large'
          onClick={() => history.push({ pathname: propertyURL, state: { properties } })}
        >
          <ADGMImage name='plusIconBlack.svg' alt='plus' />
          {messages[buttonText]?.id ? <FormattedMessage {...messages[buttonText]} /> : buttonText}
        </Button>
      </div>
    </>
  );
}

AddProperty.propTypes = {
  classes: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  propertyURL: PropTypes.string.isRequired,
  properties: PropTypes.array,
  handleRemove: PropTypes.func.isRequired,
};

AddProperty.defaultProps = {
  properties: [],
};

export default withStyles(styles)(AddProperty);
